import { render, staticRenderFns } from "./Metal.vue?vue&type=template&id=8241cd80&scoped=true&"
import script from "./Metal.vue?vue&type=script&lang=js&"
export * from "./Metal.vue?vue&type=script&lang=js&"
import style0 from "./Metal.vue?vue&type=style&index=0&id=8241cd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8241cd80",
  null
  
)

export default component.exports